import React from 'react';
import PropTypes from 'prop-types';
import { ModalConfirmation } from '@adsk/alloy-react-modal';
import { useLocale } from '@adsk/alloy-react-helpers';
import {
  DescriptionMessage,
  StyledModalBody,
  Subheading,
  SubheadingContainer,
} from './styles';

const ModalBody = ({ companyName, description, membersLabel }) => (
  <StyledModalBody>
    <DescriptionMessage>{description}</DescriptionMessage>
    <SubheadingContainer>
      <Subheading>{companyName}</Subheading>
      {membersLabel}
    </SubheadingContainer>
  </StyledModalBody>
);

const RemoveProjectCompanyModal = ({
  companyName,
  isOnConfirmInProgress,
  members,
  onClose,
  onRemoveCompany,
  projectName,
  show,
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const description = T.translate('DESCRIPTION', { projectName });
  const membersLabel = T.translate('MEMBERS', { members });

  return (
    <ModalConfirmation
      cancelButtonLabel={T.translate('CANCEL_LABEL')}
      confirmationButtonClassName="RemoveProjectCompanyContainer_button_confirmation"
      confirmationButtonLabel={T.translate('REMOVE_LABEL')}
      data-testid="RemoveProjectCompanyModal__ModalConfirmation"
      disableModalExit
      isOnConfirmInProgress={isOnConfirmInProgress}
      message={
        <ModalBody
          companyName={companyName}
          description={description}
          membersLabel={membersLabel}
        />
      }
      onClose={onClose}
      onConfirm={onRemoveCompany}
      show={show}
      style={{ maxWidth: '600px', width: '100%' }}
      title={T.translate('TITLE')}
    />
  );
};

RemoveProjectCompanyModal.propTypes = {
  companyName: PropTypes.string,
  isOnConfirmInProgress: PropTypes.bool,
  members: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemoveCompany: PropTypes.func.isRequired,
  projectName: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

RemoveProjectCompanyModal.defaultProps = {
  companyName: '',
  isOnConfirmInProgress: false,
  members: 0,
  projectName: '',
};

ModalBody.propTypes = {
  companyName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  membersLabel: PropTypes.string.isRequired,
};

export default RemoveProjectCompanyModal;
